export default "https://cdn-static.gokick.com/assets/f9e57853bbf9ca449046a7aa5fdd940e337957cb/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";